import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  formLogin: FormGroup;
  invalidLogin: boolean;

  constructor(private authService: AuthenticationService, private formBuilder: FormBuilder, private router: Router) { }

  ngOnInit() {
    this.invalidLogin = false;

    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/']).catch(err => console.log(err));
    }

    this.formLogin = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  onLogin(): void {
    if (this.formLogin.invalid) {
      return null;
    }

    this.authService.login(this.formLogin.value.username, this.formLogin.value.password).then((response) => {
      if (!response) {
        this.invalidLogin = true;
      } else {
        this.invalidLogin = false;
        this.formLogin.reset();
        this.router.navigate(['/']).catch(err => console.log(err));
      }
    });
  }
}
